import(/* webpackMode: "eager" */ "/home/tsagi/build/prod/web-dist/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/tsagi/build/prod/web-dist/src/assets/loading.svg");
